import { Typography } from '@mui/material';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { _ } from '/@/locale';
import { getAppInstance } from '/@/store/session/selectors';
import TabContainer from '../../components/tab-container';

const TermsAndConditionsTab = forwardRef((props, ref) => {
    const appInstance = useSelector(getAppInstance);

    return (
        <TabContainer title={_('Términos y condiciones')}>
            <Typography variant='body1' color='primary'>
                {_(appInstance.termsAndConditions)}
            </Typography>
        </TabContainer>
    );
});

export default TermsAndConditionsTab;
